var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox-group',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"checked":_vm.enabledFeatures,"options":_vm.options,"stacked":""},on:{"input":_vm.featuresChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }